// DEPENDENCIES
import React from 'react';
import PropTypes from 'prop-types';
// COMPONENTS
import Modal from 'react-bootstrap/Modal';
// ICONS
import { IoClose } from 'react-icons/io5';
// CUSTOM COMPONENTS
import CustomBlock from './CustomBlock';
import ContentHeader from './ContentHeader';
import Button from './Button';
// HELPERS

const ModalBlock = (props) => {
  const {
    closeIconColor,
    contentHeader,
    subtitle,
    primaryButtonText,
    contentDescription,
    children,
    buttonActionsContainerClassName,
    primaryModalActionType,
    primaryModalActionText,
    primaryModalActionColor,
    secondaryModalActionType,
    secondaryModalActionText,
    secondaryModalActionColor,
    onHide,
    closeActionOnClick,
    primaryModalActionOnClick,
    secondaryModalActionOnClick,
    isVisible,
    hasCloseAction,
    isTitleCentered,
    isPrimaryActionHidden,
    isSecondaryActionHidden,
    isPrimaryModalActionIsLoading
  } = props;

  return (
    <Modal
      {...props}
      show={isVisible}
      onHide={onHide}
    >
      {
        hasCloseAction
        && (
          <CustomBlock className="close-action-container">
            <button
              className="close-action"
              onClick={onHide || closeActionOnClick}
            >
              <IoClose
                size={30}
                className={`${closeIconColor || 'primary--clr'}`}
              />
            </button>
          </CustomBlock>
        )
      }

      <CustomBlock className="content-container--card-style content">
        <ContentHeader
          {...props}
          title={contentHeader}
          subtitle={subtitle}
          primaryButtonText={primaryButtonText}
          headerSize="mdlg"
          className="text-left"
        />

        {
          contentDescription
          && (
            <CustomBlock className={`${isTitleCentered ? 'text-center' : ''}`}>
              <p className="content-description">
                {contentDescription}
              </p>
            </CustomBlock>
          )
        }

        {children}

        {
          primaryModalActionText
          && (
            <CustomBlock className={`${buttonActionsContainerClassName} content-container--actions`}>
              {
                !isPrimaryActionHidden
                && (
                  <Button
                    type={secondaryModalActionType}
                    text={secondaryModalActionText}
                    className={secondaryModalActionColor}
                    onClick={onHide || secondaryModalActionOnClick}
                    size="xs"
                  />
                )
              }

              {
                !isSecondaryActionHidden
                && (
                  <Button
                    type={primaryModalActionType}
                    text={primaryModalActionText}
                    className={primaryModalActionColor}
                    onClick={primaryModalActionOnClick}
                    isLoading={isPrimaryModalActionIsLoading}
                    size="xs"
                  />
                )
              }
            </CustomBlock>
          )
        }
      </CustomBlock>
    </Modal>
  );
};

ModalBlock.propTypes = {
  // HEADER PROPS
  contentHeader: PropTypes.string,
  subtitle: PropTypes.string,
  primaryButtonText: PropTypes.string,

  // CLOSE ICON PROPS
  closeIconColor: PropTypes.string,

  // CONTENT PROPS
  contentDescription: PropTypes.any,
  children: PropTypes.any,

  // ACTION PROPS
  primaryModalActionText: PropTypes.string,
  buttonActionsContainerClassName: PropTypes.string,
  primaryModalActionType: PropTypes.string,
  primaryModalActionColor: PropTypes.string,
  secondaryModalActionType: PropTypes.string,
  secondaryModalActionText: PropTypes.string,
  secondaryModalActionColor: PropTypes.string,

  // FUNCTION PROPS
  onHide: PropTypes.func,
  closeActionOnClick: PropTypes.func,
  primaryModalActionOnClick: PropTypes.func,
  secondaryModalActionOnClick: PropTypes.func,

  // BOOLEAN PROPS
  isVisible: PropTypes.bool,
  hasCloseAction: PropTypes.bool,
  isTitleCentered: PropTypes.bool,
  isPrimaryActionHidden: PropTypes.bool,
  isSecondaryActionHidden: PropTypes.bool,
  isPrimaryModalActionIsLoading: PropTypes.bool,
};

ModalBlock.defaultProps = {
  // HEADER PROPS
  contentHeader: '',
  subtitle: '',
  primaryButtonText: '',

  // CLOSE ICON PROPS
  closeIconColor: '',

  // CONTENT PROPS
  contentDescription: null,
  children: null,

  // ACTION PROPS
  buttonActionsContainerClassName: '',
  primaryModalActionType: '',
  primaryModalActionText: '',
  primaryModalActionColor: 'primary--bg',
  secondaryModalActionType: '',
  secondaryModalActionText: 'Cancel',
  secondaryModalActionColor: 'danger--bg',

  // FUNCTION PROPS
  onHide: () => { },
  closeActionOnClick: () => { },
  primaryModalActionOnClick: () => { },
  secondaryModalActionOnClick: () => { },

  // BOOLEAN PROPS
  isVisible: false,
  hasCloseAction: false,
  isTitleCentered: false,
  isPrimaryActionHidden: false,
  isSecondaryActionHidden: false,
  isPrimaryModalActionIsLoading: false,
};

export default ModalBlock;